const aiFive = [
  {
      "name": "创客贴",
      "url": "https://www.chuangkit.com",
      "icon": "https://www.chuangkit.com/favicon.ico",
      "description": "流行的在线设计工具，提供海量海报、社交媒体图像、PPT等设计模板，支持拖拽式操作，适用于营销人员、自媒体及企业用户的视觉内容创作。"
  },
  {
      "name": "包图网",
      "url": "https://ibaotu.com",
      "icon": "https://ibaotu.com/favicon.ico",
      "description": "设计素材与模板平台，提供图片、视频、字体、UI组件等资源，支持分层编辑，适合设计师、市场营销人员快速获取设计资源。"
  },
  {
      "name": "Figma",
      "url": "https://www.figma.com",
      "icon": "images/figma.ico",
      "description": "云端UI/UX设计工具，支持团队实时协作、原型设计、矢量绘图，广泛应用于Web、App界面设计及交互流程规划。"
  },
  {
      "name": "Pixso",
      "url": "https://www.pixso.cn",
      "icon": "https://www.pixso.cn/favicon.ico",
      "description": "在线协同设计平台，专注于原型设计、交互效果模拟及设计系统管理，支持Figma文件导入，提升团队协作效率。"
  },
  {
      "name": "Nijijourney",
      "url": "https://nijijourney.com",
      "icon": "images/niji-journey.png",
      "description": "AI驱动的插画生成工具，支持通过文字描述生成二次元风格艺术作品，适用于游戏原画、动漫设计及个性化图像创作。"
  },
  {
      "name": "即时AI",
      "url": "https://js.design/ai",
      "icon": "https://img.js.design/assets/webImg/favicon.ico",
      "description": "可能提供实时AI设计辅助功能，如智能抠图、文案生成或图像优化，需进一步确认具体应用场景。"
  },
  {
      "name": "Adobe Firefly",
      "url": "https://www.adobe.com/products/firefly.html",
      "icon": "https://www.adobe.com/favicon.ico",
      "description": "Adobe旗下AI设计工具，集成于Creative Cloud，支持生成式AI图像创作、色彩调整及版权素材生成，提升创意设计效率。"
  },
  {
      "name": "Fiction",
      "url": "https://fiction.ai",
      "icon": "images/fiction.png",
      "description": "可能专注于故事生成、小说创作或文案辅助，利用AI算法生成连贯文本，适用于作家、自媒体的内容创作场景。"
  },
  {
      "name": "Uizard",
      "url": "https://www.uizard.io",
      "icon": "https://www.uizard.io/favicon.ico",
      "description": "AI驱动的UI设计工具，支持通过手绘草图或文字描述生成高保真原型，简化设计流程，适合快速迭代的产品开发团队。"
  },
  {
      "name": "Contentinator",
      "url": "https://contentinator.com",
      "icon": "https://contentinator.com/favicon.ico",
      "description": "可能提供内容创作、管理及优化解决方案，支持多平台内容分发，需进一步确认具体功能模块。"
  },
  {
      "name": "Galileo AI",
      "url": "https://galileo.ai",
      "icon": "https://cdn.sanity.io/images/tf66morw/production/b6ba804260aa8c85927b129e1fba84a92ea3ad87-3400x744.svg?w=3400&h=744&auto=format",
      "description": "未知具体应用领域，需进一步调查其核心功能及适用场景，暂标注为待确认的AI工具。"
  },
  {
      "name": "Clickable",
      "url": "https://clickable.com",
      "icon": "https://clickable.com/favicon.ico",
      "description": "可能用于交互式原型创建，支持动态效果设计及用户行为模拟，适用于产品经理和设计师的流程演示。"
  },
  {
      "name": "Flair",
      "url": "https://www.flair.ai",
      "icon": "images/flair.png",
      "description": "可能专注于品牌视觉设计，提供Logo、海报、社交媒体素材生成，支持自定义品牌配色及字体方案。"
  },
  {
      "name": "Pebblely",
      "url": "https://pebblely.com",
      "icon": "https://pebblely.com/favicon.ico",
      "description": "未知具体功能，推测可能与图像生成或设计素材相关，需进一步核实其应用场景。"
  },
  {
      "name": "MakeLogoAI",
      "url": "https://makelogo.com",
      "icon": "images/makelogo.png",
      "description": "专注于Logo设计的AI工具，支持用户输入品牌名称和风格，自动生成多版本Logo方案，提供下载及版权授权。",
      isVpn: true
  },
  {
      "name": "Hothot",
      "url": "https://hothot.ai",
      "icon": "images/hotpot.jpg",
      "description": "未知具体应用，需进一步调查其核心功能，暂标注为待确认的AI设计工具。",
      isVpn: true
  },
  {
      "name": "Magician",
      "url": "https://magician.design",
      "icon": "images/magician.png",
      "description": "可能是一款智能图像编辑工具，支持AI抠图、背景生成、色彩优化，简化图片处理流程。"
  },
  {
      "name": "爱设计",
      "url": "https://www.isheji.com/",
      "icon": "images/isheji-logo.png",
      "description": "面向中国市场的在线设计平台，提供海报、电商图、社交媒体素材模板，支持中文语境下的智能设计辅助。"
  },
  {
      "name": "爱设计PPT",
      "url": "https://ppt.isheji.com/",
      "icon": "images/isheji-logo.png",
      "description": "专注于演示文稿设计的工具，提供海量PPT模板、智能排版及数据可视化功能，提升商务汇报和教学课件制作效率。"
  },
  {
      "name": "美图设计室",
      "url": "https://www.designkit.com/?channel=jyshare",
      "icon": "images/meitushejishi.png",
      "description": "图片编辑与设计平台，提供智能修图、海报生成、电商素材制作，集成美图秀秀的AI图像处理技术。"
  },
  {
      "name": "Designs.ai",
      "url": "https://www.designs.ai",
      "icon": "images/designs.png",
      "description": "一站式设计服务平台，涵盖Logo生成、海报设计、视频制作等功能，支持AI驱动的自动化设计流程。"
  },
  {
      "name": "Khroma",
      "url": "https://khroma.co",
      "icon": "images/khroma.png",
      "description": "智能配色方案工具，通过AI算法生成协调的色彩组合，支持导出色卡及应用于设计项目，提升视觉一致性。"
  },
  {
      "name": "IconifyAI",
      "url": "https://iconifyai.com",
      "icon": "https://iconifyai.com/favicon.ico",
      "description": "专注于图标设计与生成的工具，支持自定义图标样式、尺寸及颜色，提供SVG格式下载，适用于UI设计和开发场景。"
  },
  {
      "name": "Noya",
      "url": "https://noya.ai",
      "icon": "https://noya.ai/favicon.ico",
      "description": "未知具体应用，需进一步调查其功能定位，暂标注为待确认的AI设计相关工具。"
  },
  {
      "name": "PLUG AI",
      "url": "https://hp.package-ai.jp/",
      "icon": "images/plug.png",
      "description": "可能是一款设计插件或集成工具，提供AI功能扩展（如智能填充、数据可视化），需确认兼容的设计平台。"
  },
  {
      "name": "Huemint",
      "url": "https://huemint.com",
      "icon": "images/huemint.png",
      "description": "专注于色彩设计的工具，提供专业配色方案、趋势分析及色值提取，适用于品牌视觉设计和网页开发。"
  },
  {
      "name": "Superflow",
      "url": "https://superflow.design",
      "icon": "https://superflow.design/favicon.ico",
      "description": "可能用于设计流程管理或原型制作，支持团队协作及版本控制，需进一步确认核心功能。"
  },
  {
      "name": "Figma",
      "url": "https://www.figma.com/ai/",
      "icon": "https://static.figma.com/app/icon/1/favicon.ico",
      "description": "信息图与图表设计工具，支持数据可视化、流程图绘制及智能排版，适用于数据分析和报告展示场景。"
  },
  {
      "name": "Appicons AI",
      "url": "https://appicons.ai",
      "icon": "https://appicons.ai/favicon.ico",
      "description": "专门用于应用程序图标设计的AI工具，支持生成多尺寸、多风格图标，适配iOS、Android等平台。"
  },
  {
      "name": "Logoai",
      "url": "https://www.logoai.com",
      "icon": "images/logoai.jpg",
      "description": "AI驱动的Logo设计平台，通过用户输入生成原创Logo方案，提供字体搭配、色彩调整及版权购买服务。"
  },
  {
      "name": "Palette",
      "url": "https://palette.tone-row.com/",
      "icon": "https://palette.tone-row.com/palette.svg",
      "description": "智能配色工具，支持从图像提取色彩或生成自定义色板，帮助设计师快速确定视觉设计的主色调。"
  },
  {
      "name": "Palette",
      "url": "https://palette.fm",
      "icon": "https://palette.fm/favicon.ico",
      "description": "智能配色工具，支持从图像提取色彩或生成自定义色板，帮助设计师快速确定视觉设计的主色调。"
  },
  {
      "name": "illustrationAI",
      "url": "https://www.illostration.com/",
      "icon": "https://www.illostration.com/mc_symbol.svg",
      "description": "专注于插画生成的AI工具，支持多种艺术风格（如扁平、写实、卡通），适用于书籍插画、广告设计及文创产品开发。"
  },
  {
      "name": "lllustroke",
      "url": "https://illustroke.com/",
      "icon": "images/illustroke.jpg",
      "description": "矢量图形绘制或AI辅助插画相关，需进一步核实。"
  },
  {
    "name": "Eva Design",
    "url": "https://eva.design",
    "icon": "https://cdn.prod.website-files.com/5cae1b363eb34f46e5045f93/5f466a89bc19cca93f2170e8_eva-logo.svg",
    "description": "综合设计工具，提供UI/UX设计、原型制作及协作功能，支持多平台适配和设计系统管理。"
},
  {
      "name": "Color Wheel",
      "url": "https://colors.eva.design/",
      "icon": "https://cdn.prod.website-files.com/5cae1b363eb34f46e5045f93/5f466a89bc19cca93f2170e8_eva-logo.svg",
      "description": "色彩搭配工具，支持色轮选择、互补色/类似色推荐，帮助设计师创建和谐的视觉配色方案。"
  },
  {
      "name": "Logomaster.ai",
      "url": "https://logomaster.ai",
      "icon": "https://logomaster.ai/favicon.ico",
      "description": "专业Logo设计平台，结合AI算法生成独特Logo，提供编辑工具及品牌视觉延展方案，适合中小企业品牌建设。"
  },
  {
      "name": "Looka",
      "url": "https://looka.com",
      "icon": "images/looka_logo_black.svg",
      "description": "提供品牌设计服务的平台，包括Logo设计、社交媒体模板、品牌手册生成，支持AI驱动的自动化设计流程。"
  },
  {
      "name": "Daft Art",
      "url": "https://daftart.ai",
      "icon": "https://daftart.ai/favicon.ico",
      "description": "AI艺术创作工具，支持生成抽象画、数字艺术作品，适用于艺术家和创意工作者的灵感激发。",

  },
  {
      "name": "ColorMagic",
      "url": "https://www.zams.com/",
      "icon": "https://cdn.prod.website-files.com/678a7f2dda7bdd45b1e4d835/678a823b1dac4db544e05b75_logo.svg",
      "description": "智能色彩调整工具，自动优化图像色彩平衡、对比度及色调，提升图片视觉效果。",
      isVpn: true
  },
  {
      "name": "PixAI",
      "url": "http://www.pixai.art/",
      "icon": "images/pixai.jpg",
      "description": "图像编辑与增强工具，利用AI技术实现智能降噪、超分辨率及风格迁移，适用于摄影师和设计师的后期处理。",
      isVpn: true
  },
  {
      "name": "DreamGF.ai",
      "url": "https://dreamgf.ai",
      "icon": "images/dreamgf.png",
      "description": "未知具体应用，需进一步调查其功能，暂标注为待确认的AI图像或设计工具。",
      isVpn: true
  },
  {
      "name": "Microsoft D",
      "url": "https://designer.microsoft.com/",
      "icon": "images/microsoft-deginer.png",
      "description": "可能指微软设计工具或AI设计功能，如Designer智能设计助手，支持PPT、海报等素材生成。"
  },
  {
      "name": "易可图",
      "url": "https://www.yiketu.com/",
      "icon": "https://cs-c2.yiketu.com/assets/logo-positive-da6839d5.svg",
      "description": "面向中国市场的设计工具，提供模板化设计、智能抠图及电商素材制作，降低设计技术门槛。"
  },
  {
      "name": "绘蛙",
      "url": "https://www.ihuiwa.com/",
      "icon": "images/ihuiwa.png",
      "description": "绘画与设计工具，支持手绘板接入及AI辅助绘图，适合插画师和艺术爱好者的创作需求。"
  },
  {
      "name": "Recaft V3",
      "url": "https://www.recraft.ai/",
      "icon": "images/recraft.png",
      "description": "未知具体应用，需进一步确认其功能，暂标注为待确认的设计相关工具。"
  },
  {
      "name": "千图网",
      "url": "https://www.58pic.com",
      "icon": "https://www.58pic.com/favicon.ico",
      "description": "设计素材共享平台，提供图片、矢量图、PSD模板等资源，支持关键词搜索及分类筛选，适合设计师快速获取素材。"
  },
  {
      "name": "稿定AI",
      "url": "https://www.gaoding.com/ai",
      "icon": "https://www.gaoding.com/favicon.ico",
      "description": "智能文案创作工具，支持商品描述、营销文案生成，结合设计模板实现图文一体化输出。"
  },
  {
      "name": "鹿班",
      "url": "https://luban.aliyun.com",
      "icon": "https://luban.aliyun.com/favicon.ico",
      "description": "阿里巴巴推出的智能设计工具，支持电商海报、详情页自动生成，提升商家视觉设计效率。"
  },
  {
      "name": "羚珑",
      "url": "https://ling.jd.com/",
      "icon": "images/linglong.png",
      "description": "电商设计或智能排版相关，需进一步确认核心功能。"
  },
  {
      "name": "智绘设计",
      "url": "https://taishan.qq.com/brand/",
      "icon": "http://static.taishan.qq.com/editor/img/header/logo.png",
      "description": "综合设计平台，提供AI辅助绘图、智能排版及多格式导出，适用于中小团队的视觉设计需求。"
  },
  {
      "name": "Canva可画",
      "url": "https://www.canva.cn/?display-com-option=true",
      "icon": "https://static.canva.cn/web/images/f9657e6b25961d7a7d94cb78c0192507.svg",
      "description": "综合设计平台，提供AI辅助绘图、智能排版及多格式导出，适用于中小团队的视觉设计需求。"
  },
  {
      "name": "墨刀AI",
      "url": "https://modao.cc",
      "icon": "https://modao.cc/favicon.ico",
      "description": "集成于墨刀设计工具的AI功能，提供智能原型生成、交互效果推荐，提升产品原型设计效率。"
  },
  {
      "name": "MasterGO AI",
      "url": "https://mastergo.com",
      "icon": "https://mastergo.com/favicon.ico",
      "description": "设计与原型制作工具，结合AI实现智能布局、组件生成及协作管理，适用于团队化产品设计流程。"
  },
  {
      "name": "美间",
      "url": "https://www.meijian.com/introduction",
      "icon": "https://qhstaticssl.kujiale.com/image/png/1715739350222/C7C4F56411E0030592353BDDF18236AE.png?x-oss-process=image/format,webp",
      "description": "室内设计可视化工具，提供家具模型库、空间布局规划及3D渲染，帮助设计师快速呈现设计方案。"
  },
  {
      "name": "阿里PicCopilot",
      "url": "https://www.piccopilot.com/",
      "icon": "images/piccopilot.png",
      "description": "阿里云图像生成工具，支持商品图智能合成、背景替换及批量处理，适用于电商平台商品图片优化。"
  },
  {
      "name": "堆友",
      "url": "https://d.design/",
      "icon": "images/duiyou.png",
      "description": "未知具体应用，推测可能与设计素材或协作相关，需进一步确认功能模块。"
  },
  {
      "name": "即创",
      "url": "https://aic.oceanengine.com/login",
      "icon": "images/jichuang.png",
      "description": "快速设计与原型制作工具，支持模板化操作及智能推荐，适合快速迭代的设计场景。"
  },
  {
      "name": "笔魂AI",
      "url": "https://ibihun.com/",
      "icon": "images/ibihun.png",
      "description": "可能专注于字体设计或生成，提供个性化字体方案及字符编辑工具，适用于品牌视觉设计。"
  },
  {
      "name": "Figma AI",
      "url": "https://www.figma.com",
      "icon": "images/figma.jpg",
      "description": "Figma集成的AI功能，包括智能文本生成、图像填充及设计建议，提升界面设计效率。",
      isVpn: true
  },
  {
      "name": "蚂上有创意",
      "url": "https://idesign.alipay.com/home",
      "icon": "images/idesign.png",
      "description": "设计与创意工具，提供智能排版、素材推荐及实时协作，帮助团队快速产出创意方案。"
  },

  {
      "name": "Onlook",
      "url": "https://onlook.com/",
      "icon": "images/idesign.png",
      "description": "未知具体应用，需进一步调查其功能，暂标注为待确认的AI设计相关工具。"
  },
  {
      "name": "FigJam AI",
      "url": "https://www.figma.com/figjam/ai/",
      "icon": "images/figjam.png",
      "description": "Figma旗下协作工具的AI功能，支持智能会议记录、流程图生成及团队脑暴，提升协作效率。"
  },
  {
      "name": "简单设计",
      "url": "https://jiandan.link/",
      "icon": "images/jiandan.svg",
      "description": "易于使用的设计工具，提供拖拽式操作、海量模板，适合设计新手快速完成海报、名片等视觉设计。"
  },
  {
      "name": "135AI排版",
      "url": "https://www.135editor.com/ai_editor/",
      "icon": "images/135paiban.png",
      "description": "专注于排版的AI工具，支持微信公众号、电商详情页智能排版，提供多风格模板及自适应布局。"
  },
  {
      "name": "笔格设计",
      "url": "https://bigesj.com/",
      "icon": "images/135paiban.png",
      "description": "设计与布局工具，提供网格系统辅助、智能对齐及尺寸适配，提升设计作品的规范性。"
  },
  {
      "name": "豆绘AI",
      "url": "https://www.douhuiai.com/",
      "icon": "images/douhui.jpg",
      "description": "绘画与设计工具，支持AI辅助绘图、色彩搭配及作品分享，适合插画师和艺术爱好者使用。"
  },
  {
      "name": "VoxCraft",
      "url": "https://www.vidu.cn/",
      "icon": "images/vidu.jpg",
      "description": "未知具体应用，需进一步调查其功能，暂标注为待确认的AI设计相关工具。"
  },
  {
      "name": "Pictographic",
      "url": "https://www.pictographic.io/",
      "icon": "images/pictographic.png",
      "description": "信息图设计工具，支持数据可视化、时间线绘制及图标库调用，适用于报告、演示文稿的视觉呈现。"
  },
  {
      "name": "Fable Prism",
      "url": "https://www.fable.app/prism",
      "icon": "images/fable.png",
      "description": "未知具体功能，推测可能与3D设计或图像渲染相关，需进一步核实。"
  },
  {
      "name": "Wegic",
      "url": "https://wegic.ai/zh-cn",
      "icon": "images/wegic.png",
      "description": "设计与创意平台，提供AI图像生成、视频编辑及多平台发布，支持一站式内容创作流程。"
  },
  {
      "name": "匠紫",
      "url": "https://jiangziai.com/",
      "icon": "images/jiangzi.jpg",
      "description": "设计与图像编辑工具，提供专业级调色、修图及特效，适用于摄影师和设计师的精细处理需求。"
  },
  {
      "name": "Collov AI",
      "url": "https://collov.cn/",
      "icon": "images/collov.jpg",
      "description": "协作式设计工具，支持室内设计方案共享、3D模型展示及智能推荐，提升设计团队协作效率。"
  },
  {
      "name": "Creatie",
      "url": "https://creatie.ai",
      "icon": "https://creatie.ai/favicon.ico",
      "description": "创意设计工具，提供AI灵感生成、素材推荐及实时协作，帮助设计师突破创意瓶颈。"
  },
  {
      "name": "Kittl",
      "url": "https://kittl.com",
      "icon": "https://kittl.com/favicon.ico",
      "description": "设计与排版工具，提供社交媒体素材、海报模板及智能图文匹配，适合快速内容生产。"
  },
  {
      "name": "Stylar",
      "url": "https://stylar.ai",
      "icon": "images/stylar.jpg",
      "description": "风格化设计工具，支持图像风格迁移、字体样式匹配及品牌视觉统一，提升设计作品的独特性。"
  },
  {
      "name": "llus AI",
      "url": "https://ilus.ai/",
      "icon": "images/Ilus.png",
      "description": "未知具体应用，需进一步调查其功能，暂标注为待确认的AI设计相关工具。"
  },
  {
      "name": "酷家乐AI",
      "url": "https://www.kujiale.cn/activities/AI-kujiale",
      "icon": "images/kujiale.jpg",
      "description": "室内设计可视化工具，利用AI实现户型智能规划、家具自动摆放及3D渲染，提升装修设计效率。"
  }
]

export default aiFive
